<script>
import { defineComponent, toRefs } from 'vue'

import useRoundHallPlacePosition from './hooks/useRoundHallPlacePosition'

export default defineComponent({
  props: {
    row: { type: String, required: true },
    hallCathegory: { type: String, default: () => '' },
    placeKey: { type: String, required: true },
    place: { type: Object, required: true },
    amphitheater: {
      type: Boolean,
      default: false
    },
    parther: {
      type: Boolean,
      default: false
    },
    popupComponent: { type: [Object, null], default: null },
    tickets: { type: Array, default: () => [] },
    cart: { type: Array, default: () => [] }
  },
  emits: ['addTicketToCart', 'removeTicketFromCart'],
  methods: {},
  setup(props) {
    const { row, placeKey } = toRefs(props)
    const { float, marginLeft, marginRight } = useRoundHallPlacePosition({
      row,
      placeKey
    })

    return {
      float,
      marginLeft,
      marginRight
    }
  }
})
</script>

<template>
  <!-- {{ hallCathegory == 'round-hall' }} -->
  <div
    class="relative flex"
    :class="hallCathegory == 'round-hall' ? 'px-3/2' : ''"
    :style="
      hallCathegory == 'round-hall'
        ? {
            float: float,
            marginRight: `${marginRight}px`,
            marginLeft: `${marginLeft}px`
          }
        : ''
    "
  >
    <span
      class="
        h-9
        w-9
        pt-2
        block
        relative
        font-sans font-lg2
        leading-5
        rounded-lg
        text-center
        align-baseline
        text-white
        bg-gray
      "
    >
      {{ placeKey }}
    </span>
  </div>
</template>
